import axios from 'config/axios'

export const update = payload => axios.patch('/alcatraz/v2/electronicsignature', payload)

export const recovery = () =>
  axios.post('alcatraz/electronicsignature/recovery', undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      'content-type': 'text/plain'
    }
  })

export const axiosDefault = axios
